<template>
	<v-autocomplete v-bind="$attrs" :label="$t('pages.projectForm.city')" v-model="citySelect" :items="cities" :clearable="true" :required="required">
		<template v-slot:append>
			<v-icon x-small v-if="required" color="red lighten-2">mdi-asterisk</v-icon>
		</template>
	</v-autocomplete>
</template>

<script>
	import {types} from "src/store/modules/City.module";

	export default {
		name: "cites-select",
		props: {
			value: {},
			required: {type: Boolean, default: false}
		},
		components: {},
		data() {
			return {};
		},
		computed: {
			cities() {
				return this.$store.state.CityModule.cities.map((city)=>city.name);
			},
			citySelect: {
				get() {
					return this.value;
				},
				set(m) {
					this.$emit("input", m);
				}
			}
		},
		created() {
			this.$store.dispatch(types.FETCH);
		}

	};
</script>

<style scoped>

</style>
